module.exports = __webpack_public_path__ + "static/media/ge.0386b636.svg";